import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {ClientSettingsService} from '../services/settings/client-settings.service';
import {isNil} from 'lodash';

@Injectable()
export class RouteGuard implements CanActivate {
  constructor(private clientSettings: ClientSettingsService,
              private router?: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (isNil(localStorage.getItem('loggedUser'))) { // logged in so return true
      this.router.navigate(['ng/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    if (route.data && route.data.requireEUpravaStockroom) {
      const activeStockroom = this.clientSettings.getActiveStockroom();
      if (isNil(activeStockroom) || isNil(activeStockroom.id) || !activeStockroom.eUprava) {
        this.router.navigate(['/ng/home']);
        return false;
      }
    }

    // const acomp = this.clientSettings.getActiveCompany();
    // const astr = this.clientSettings.getActiveStockroom();
    //
    // if ((!isNil(acomp) && acomp.id == null) || (!isNil(astr) && astr.id == null)) {
    //   const wmr = WebMethodResult.create(-1, 'Kompanija ili magacin nije izabran! Ne možete nastaviti sa radom');
    //   // this.router.navigate(['ng/home'], {queryParams: {errorObj: JSON.stringify(wmr)}});
    //   console.log('Kompanija ili magacin nije izabran! Ne možete nastaviti sa radom');
    //   return false;
    // }
    return true;
  }
}
